// IllumiDev Complete Services Catalog
// Bilingual: Spanish (es) and English (en)

export const SERVICES_CATALOG = {
  es: {
    categories: [
      {
        id: 'ai-automation',
        name: 'AI & Automatización',
        icon: 'Brain',
        color: '#8B5CF6',
        services: [
          { id: 'ai-workflow', name: 'Diseño de workflows IA', basePrice: 800, description: 'Flujos de trabajo inteligentes con IA' },
          { id: 'custom-ai-assistants', name: 'Asistentes IA personalizados', basePrice: 1200, description: 'Chatbots y asistentes virtuales a medida' },
          { id: 'task-automation', name: 'Automatización de tareas', basePrice: 600, description: 'Elimina tareas repetitivas automáticamente' },
          { id: 'crm-automation', name: 'Automatización CRM y pipeline', basePrice: 900, description: 'Flujos de ventas automatizados' },
          { id: 'email-calendar-automation', name: 'Automatización email y calendario', basePrice: 500, description: 'Emails y agendas en piloto automático' },
          { id: 'document-automation', name: 'Automatización de documentos', basePrice: 700, description: 'Generación y procesamiento automático de docs' },
        ]
      },
      {
        id: 'app-development',
        name: 'Apps & Desarrollo de Sistemas',
        icon: 'Code',
        color: '#3B82F6',
        services: [
          { id: 'custom-web-apps', name: 'Aplicaciones web personalizadas', basePrice: 2500, description: 'Apps a medida para tu negocio' },
          { id: 'internal-tools', name: 'Herramientas internas de negocio', basePrice: 1800, description: 'Software interno para tu equipo' },
          { id: 'mvp-development', name: 'Desarrollo de MVP', basePrice: 3000, description: 'Producto mínimo viable rápido' },
          { id: 'client-portals', name: 'Portales de clientes', basePrice: 2000, description: 'Acceso exclusivo para tus clientes' },
          { id: 'booking-systems', name: 'Sistemas de reservas y agenda', basePrice: 1200, description: 'Citas y reservaciones online' },
          { id: 'onboarding-systems', name: 'Sistemas de onboarding', basePrice: 1500, description: 'Procesos de entrada automatizados' },
        ]
      },
      {
        id: 'business-operations',
        name: 'Operaciones de Negocio',
        icon: 'Settings',
        color: '#10B981',
        services: [
          { id: 'recruiting-workflows', name: 'Sistemas de workflow de reclutamiento', basePrice: 1400, description: 'Procesos de contratación optimizados' },
          { id: 'candidate-tracking', name: 'Sistemas de seguimiento de candidatos', basePrice: 1200, description: 'ATS personalizado' },
          { id: 'client-intake', name: 'Intake de clientes y órdenes de trabajo', basePrice: 900, description: 'Captura y gestión de solicitudes' },
          { id: 'staffing-optimization', name: 'Optimización de staffing y onboarding', basePrice: 1100, description: 'Procesos de personal eficientes' },
          { id: 'operations-audits', name: 'Auditorías de operaciones', basePrice: 800, description: 'Análisis y mejora de procesos' },
          { id: 'sop-mapping', name: 'Mapeo de SOPs y workflows', basePrice: 700, description: 'Documentación de procedimientos' },
        ]
      },
      {
        id: 'websites',
        name: 'Sitios Web & Presencia Digital',
        icon: 'Globe',
        color: '#F59E0B',
        services: [
          { id: 'landing-pages', name: 'Landing pages', basePrice: 499, description: 'Páginas de aterrizaje que convierten' },
          { id: 'business-websites', name: 'Sitios web de negocio', basePrice: 1200, description: 'Presencia profesional completa' },
          { id: 'sales-pages', name: 'Páginas de ventas', basePrice: 800, description: 'Páginas optimizadas para conversión' },
          { id: 'portfolio-sites', name: 'Sitios portfolio', basePrice: 900, description: 'Muestra tu trabajo con estilo' },
          { id: 'website-refresh', name: 'Refresh y optimización de sitio', basePrice: 600, description: 'Actualización y mejora de tu web actual' },
          { id: 'conversion-redesign', name: 'Rediseño enfocado en conversión', basePrice: 1500, description: 'Rediseño estratégico para resultados' },
        ]
      },
      {
        id: 'branding-ux',
        name: 'Branding & UX',
        icon: 'Palette',
        color: '#EC4899',
        services: [
          { id: 'brand-direction', name: 'Dirección de marca digital', basePrice: 1000, description: 'Estrategia visual para productos digitales' },
          { id: 'ui-ux-design', name: 'Diseño UI/UX', basePrice: 1200, description: 'Interfaces intuitivas y atractivas' },
          { id: 'user-journey-mapping', name: 'Mapeo de user journey', basePrice: 600, description: 'Optimiza la experiencia del usuario' },
          { id: 'visual-systems', name: 'Sistemas visuales para apps', basePrice: 900, description: 'Design systems consistentes' },
          { id: 'interface-cleanup', name: 'Limpieza y modernización de interfaz', basePrice: 700, description: 'Actualización visual de tu producto' },
        ]
      },
      {
        id: 'content-launch',
        name: 'Contenido & Soporte de Lanzamiento',
        icon: 'Rocket',
        color: '#EF4444',
        services: [
          { id: 'promo-graphics', name: 'Gráficos promocionales', basePrice: 400, description: 'Materiales visuales de marketing' },
          { id: 'launch-assets', name: 'Assets de lanzamiento', basePrice: 600, description: 'Todo lo necesario para tu launch' },
          { id: 'product-copywriting', name: 'Copywriting de producto', basePrice: 500, description: 'Textos que venden' },
          { id: 'service-page-writing', name: 'Escritura de páginas de servicios', basePrice: 400, description: 'Descripciones de servicios efectivas' },
          { id: 'pitch-decks', name: 'Pitch decks y presentaciones', basePrice: 800, description: 'Presentaciones que impactan' },
          { id: 'demo-flows', name: 'Creación de flujos demo', basePrice: 700, description: 'Demos interactivos de producto' },
        ]
      },
      {
        id: 'data-insights',
        name: 'Datos & Insights',
        icon: 'BarChart3',
        color: '#06B6D4',
        services: [
          { id: 'dashboard-setup', name: 'Configuración de dashboards', basePrice: 900, description: 'Tableros de control personalizados' },
          { id: 'business-reporting', name: 'Sistemas de reporting de negocio', basePrice: 1100, description: 'Reportes automáticos' },
          { id: 'kpi-tracking', name: 'Tracking de KPIs', basePrice: 700, description: 'Monitoreo de métricas clave' },
          { id: 'operational-visibility', name: 'Herramientas de visibilidad operacional', basePrice: 800, description: 'Transparencia en tus operaciones' },
          { id: 'data-cleanup', name: 'Organización y limpieza de datos', basePrice: 500, description: 'Datos limpios y estructurados' },
        ]
      },
      {
        id: 'ongoing-support',
        name: 'Soporte Continuo',
        icon: 'HeartHandshake',
        color: '#84CC16',
        services: [
          { id: 'tech-maintenance', name: 'Mantenimiento técnico', basePrice: 300, perMonth: true, description: 'Mantenimiento mensual de sistemas' },
          { id: 'system-updates', name: 'Actualizaciones de sistema', basePrice: 200, perMonth: true, description: 'Updates y mejoras regulares' },
          { id: 'automation-troubleshooting', name: 'Troubleshooting de automatizaciones', basePrice: 150, perHour: true, description: 'Solución de problemas de automatización' },
          { id: 'feature-improvements', name: 'Mejoras de funcionalidades', basePrice: 100, perHour: true, description: 'Nuevas features y optimizaciones' },
          { id: 'monthly-retainer', name: 'Retainer mensual de soporte', basePrice: 500, perMonth: true, description: 'Soporte prioritario mensual' },
        ]
      }
    ],
    coreServices: [
      { name: 'Desarrollo de Apps Personalizadas', icon: 'Smartphone' },
      { name: 'Asistentes IA & Automatización', icon: 'Bot' },
      { name: 'Diseño de Sistemas de Negocio', icon: 'Workflow' },
      { name: 'Sitios Web & Portales de Clientes', icon: 'Globe' },
      { name: 'Optimización de Operaciones', icon: 'TrendingUp' },
      { name: 'CRM, ATS & Configuración de Workflows', icon: 'Users' },
      { name: 'Diseño UI/UX', icon: 'Palette' },
      { name: 'Dashboards & Reportes', icon: 'BarChart3' },
      { name: 'Soporte de Lanzamiento & Assets Digitales', icon: 'Rocket' },
      { name: 'Soporte Técnico Continuo', icon: 'HeartHandshake' },
    ]
  },
  en: {
    categories: [
      {
        id: 'ai-automation',
        name: 'AI & Automation',
        icon: 'Brain',
        color: '#8B5CF6',
        services: [
          { id: 'ai-workflow', name: 'AI workflow design', basePrice: 800, description: 'Intelligent AI-powered workflows' },
          { id: 'custom-ai-assistants', name: 'Custom AI assistants', basePrice: 1200, description: 'Tailored chatbots and virtual assistants' },
          { id: 'task-automation', name: 'Task automation', basePrice: 600, description: 'Eliminate repetitive tasks automatically' },
          { id: 'crm-automation', name: 'CRM and pipeline automation', basePrice: 900, description: 'Automated sales flows' },
          { id: 'email-calendar-automation', name: 'Email, calendar, and admin automation', basePrice: 500, description: 'Emails and calendars on autopilot' },
          { id: 'document-automation', name: 'Document and form automation', basePrice: 700, description: 'Automatic document generation and processing' },
        ]
      },
      {
        id: 'app-development',
        name: 'App & System Development',
        icon: 'Code',
        color: '#3B82F6',
        services: [
          { id: 'custom-web-apps', name: 'Custom web apps', basePrice: 2500, description: 'Tailored apps for your business' },
          { id: 'internal-tools', name: 'Internal business tools', basePrice: 1800, description: 'Internal software for your team' },
          { id: 'mvp-development', name: 'MVP development', basePrice: 3000, description: 'Fast minimum viable product' },
          { id: 'client-portals', name: 'Client portals', basePrice: 2000, description: 'Exclusive access for your clients' },
          { id: 'booking-systems', name: 'Booking and scheduling systems', basePrice: 1200, description: 'Online appointments and reservations' },
          { id: 'onboarding-systems', name: 'Onboarding and intake systems', basePrice: 1500, description: 'Automated entry processes' },
        ]
      },
      {
        id: 'business-operations',
        name: 'Business Operations',
        icon: 'Settings',
        color: '#10B981',
        services: [
          { id: 'recruiting-workflows', name: 'Recruiting workflow systems', basePrice: 1400, description: 'Optimized hiring processes' },
          { id: 'candidate-tracking', name: 'Candidate tracking systems', basePrice: 1200, description: 'Custom ATS' },
          { id: 'client-intake', name: 'Client intake and work order systems', basePrice: 900, description: 'Request capture and management' },
          { id: 'staffing-optimization', name: 'Staffing and onboarding optimization', basePrice: 1100, description: 'Efficient personnel processes' },
          { id: 'operations-audits', name: 'Operations audits', basePrice: 800, description: 'Process analysis and improvement' },
          { id: 'sop-mapping', name: 'SOP and workflow mapping', basePrice: 700, description: 'Procedure documentation' },
        ]
      },
      {
        id: 'websites',
        name: 'Websites & Digital Presence',
        icon: 'Globe',
        color: '#F59E0B',
        services: [
          { id: 'landing-pages', name: 'Landing pages', basePrice: 499, description: 'High-converting landing pages' },
          { id: 'business-websites', name: 'Business websites', basePrice: 1200, description: 'Complete professional presence' },
          { id: 'sales-pages', name: 'Sales pages', basePrice: 800, description: 'Conversion-optimized pages' },
          { id: 'portfolio-sites', name: 'Portfolio sites', basePrice: 900, description: 'Showcase your work with style' },
          { id: 'website-refresh', name: 'Website refresh and optimization', basePrice: 600, description: 'Update and improve your current site' },
          { id: 'conversion-redesign', name: 'Conversion-focused redesigns', basePrice: 1500, description: 'Strategic redesign for results' },
        ]
      },
      {
        id: 'branding-ux',
        name: 'Branding & UX',
        icon: 'Palette',
        color: '#EC4899',
        services: [
          { id: 'brand-direction', name: 'Brand direction for digital products', basePrice: 1000, description: 'Visual strategy for digital products' },
          { id: 'ui-ux-design', name: 'UI/UX design', basePrice: 1200, description: 'Intuitive and attractive interfaces' },
          { id: 'user-journey-mapping', name: 'User journey mapping', basePrice: 600, description: 'Optimize user experience' },
          { id: 'visual-systems', name: 'Visual systems for apps and websites', basePrice: 900, description: 'Consistent design systems' },
          { id: 'interface-cleanup', name: 'Interface cleanup and modernization', basePrice: 700, description: 'Visual update for your product' },
        ]
      },
      {
        id: 'content-launch',
        name: 'Content & Launch Support',
        icon: 'Rocket',
        color: '#EF4444',
        services: [
          { id: 'promo-graphics', name: 'Promo graphics for apps and brands', basePrice: 400, description: 'Marketing visual materials' },
          { id: 'launch-assets', name: 'Launch assets', basePrice: 600, description: 'Everything you need for your launch' },
          { id: 'product-copywriting', name: 'Product copywriting', basePrice: 500, description: 'Copy that sells' },
          { id: 'service-page-writing', name: 'Service page writing', basePrice: 400, description: 'Effective service descriptions' },
          { id: 'pitch-decks', name: 'Pitch decks and presentations', basePrice: 800, description: 'Impactful presentations' },
          { id: 'demo-flows', name: 'Demo flow creation', basePrice: 700, description: 'Interactive product demos' },
        ]
      },
      {
        id: 'data-insights',
        name: 'Data & Insights',
        icon: 'BarChart3',
        color: '#06B6D4',
        services: [
          { id: 'dashboard-setup', name: 'Dashboard setup', basePrice: 900, description: 'Custom control panels' },
          { id: 'business-reporting', name: 'Business reporting systems', basePrice: 1100, description: 'Automated reports' },
          { id: 'kpi-tracking', name: 'KPI tracking', basePrice: 700, description: 'Key metrics monitoring' },
          { id: 'operational-visibility', name: 'Operational visibility tools', basePrice: 800, description: 'Transparency in your operations' },
          { id: 'data-cleanup', name: 'Data organization and cleanup', basePrice: 500, description: 'Clean and structured data' },
        ]
      },
      {
        id: 'ongoing-support',
        name: 'Ongoing Support',
        icon: 'HeartHandshake',
        color: '#84CC16',
        services: [
          { id: 'tech-maintenance', name: 'Tech maintenance', basePrice: 300, perMonth: true, description: 'Monthly system maintenance' },
          { id: 'system-updates', name: 'System updates', basePrice: 200, perMonth: true, description: 'Regular updates and improvements' },
          { id: 'automation-troubleshooting', name: 'Automation troubleshooting', basePrice: 150, perHour: true, description: 'Automation problem solving' },
          { id: 'feature-improvements', name: 'Feature improvements', basePrice: 100, perHour: true, description: 'New features and optimizations' },
          { id: 'monthly-retainer', name: 'Monthly support retainer', basePrice: 500, perMonth: true, description: 'Priority monthly support' },
        ]
      }
    ],
    coreServices: [
      { name: 'Custom App Development', icon: 'Smartphone' },
      { name: 'AI Assistants & Automation', icon: 'Bot' },
      { name: 'Business Systems Design', icon: 'Workflow' },
      { name: 'Websites & Client Portals', icon: 'Globe' },
      { name: 'Operations Optimization', icon: 'TrendingUp' },
      { name: 'CRM, ATS & Workflow Setup', icon: 'Users' },
      { name: 'UI/UX Design', icon: 'Palette' },
      { name: 'Dashboards & Reporting', icon: 'BarChart3' },
      { name: 'Launch Support & Digital Assets', icon: 'Rocket' },
      { name: 'Ongoing Tech Support', icon: 'HeartHandshake' },
    ]
  }
};

// Helper function to get all services flat
export const getAllServices = (language = 'es') => {
  const catalog = SERVICES_CATALOG[language];
  return catalog.categories.flatMap(cat => 
    cat.services.map(service => ({
      ...service,
      categoryId: cat.id,
      categoryName: cat.name,
      categoryColor: cat.color,
    }))
  );
};

// Helper function to calculate total price
export const calculatePackagePrice = (selectedServices, language = 'es') => {
  const allServices = getAllServices(language);
  let oneTimeTotal = 0;
  let monthlyTotal = 0;
  let hourlyServices = [];

  selectedServices.forEach(serviceId => {
    const service = allServices.find(s => s.id === serviceId);
    if (service) {
      if (service.perMonth) {
        monthlyTotal += service.basePrice;
      } else if (service.perHour) {
        hourlyServices.push(service);
      } else {
        oneTimeTotal += service.basePrice;
      }
    }
  });

  return {
    oneTimeTotal,
    monthlyTotal,
    hourlyServices,
    hasRecurring: monthlyTotal > 0 || hourlyServices.length > 0,
  };
};

export default SERVICES_CATALOG;
